import moment from "moment";
import { API_URL } from "../../constants/api";
import ToastMsg from "./ToastMsg";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

export const transformUserPermissionArr = (listData) => {
    if (listData?.length > 0) {
        let transformedArray = listData.map(module => {
            let subMenu = [];
            let modulePermission = false;

            if (module.module_name === 'home' ||
                module.module_name === 'dashboard' ||
                module.module_name === 'roster'
            ) {
                let moduleList = module.module_list[module.module_name];
                return {
                    label: module.module_name,
                    permission: moduleList.permission,
                    active: moduleList.active,
                    edit: moduleList.edit,
                    add: moduleList.add,
                    draft: moduleList.draft
                };
            } else {
                for (const [key, value] of Object.entries(module.module_list)) {
                    subMenu.push({
                        label: key,
                        permission: value.permission,
                        add: value.add,
                        edit: value.edit,
                        draft: value.draft,
                        active: value.active
                    });
                    if (value.permission) {
                        modulePermission = true;
                    }
                }
            }
            return {
                label: module.module_name,
                permission: modulePermission,
                subMenu: subMenu
            };
        });
        return transformedArray;
    }
}

export const checkUserPermissionFunc = (MenuName, SubMenuName = null, Type) => {
    try {
        let accessObject = undefined;
        let userPermissionList = JSON.parse(sessionStorage.getItem("loginUserPermission"));
        let accessData = userPermissionList?.length > 0 ? userPermissionList : [];
        // const isAdmin = JSON.parse(sessionStorage.getItem("is_admin"));

        // if (!isAdmin) {  // Check Access only for User role
        let data = {}
        if (Type === 'Menu') {
            data = accessData.find(list => list['label'].toLowerCase().replace(/_/g, " ") === MenuName.toLowerCase())
        } else if (Type === 'SubMenu') {
            data = accessData.find(menu => menu['label'].toLowerCase().replace(/_/g, " ") === MenuName.toLowerCase())
            data = data.subMenu.find(item => item['label'].toLowerCase().replace(/_/g, " ") === SubMenuName.toLowerCase());
        }
        if (data) {
            accessObject = data;
        }
        // }
        if (accessObject === undefined) {
            return {
                "add": false,
                "edit": false,
                "draft": false,
                "active": false,
                "permission": false
            }
        } else {
            return accessObject
        }
    }
    catch (e) {
        // if (JSON.parse(sessionStorage.getItem("is_admin"))) {
        //     return {
        //         "add": true,
        //         "edit": true,
        //         "draft": true,
        //         "active": true,
        //         "permission": true
        //     };
        // } else {
        return {
            "add": false,
            "edit": false,
            "draft": false,
            "active": false,
            "permission": false
        };
        // }
    }
}

const normalize = (str) => str?.toLowerCase().replace(/_/g, " ").trim();

export const buildDynamicNav = (navItems, permissions, defaults) => {
    return navItems
        .map((menu) => {
            const menuLabel = normalize(menu.label).toLowerCase();

            const menuPerm = permissions.find(
                (perm) => normalize(perm.label) === menuLabel
            );

            const isFullDefault = defaults.fullMenus?.includes(menuLabel);

            // allow menu if either permissions exist AND are true OR it's in defaults
            if ((!menuPerm || menuPerm.permission === false) && !defaults[normalize(menu.label)] && !isFullDefault) {
                return null;
            }


            let filteredSubItems = menu.subItems || [];

            if (filteredSubItems.length > 0) {
                filteredSubItems = filteredSubItems.filter((sub) => {
                    const subLabel = normalize(sub.label);

                    // keep always if default
                    const isDefault = defaults[normalize(menu.label)]?.includes(subLabel);
                    if (isDefault) return true;

                    // otherwise check permission
                    return menuPerm?.subMenu?.some(
                        (permSub) =>
                            normalize(permSub.label) === subLabel && permSub.permission
                    );
                });
            }

            if (filteredSubItems.length > 0) {
                return { ...menu, subItems: filteredSubItems };
            }

            // if no subItems, return menu directly 
            return { ...menu };
        })
        .filter(Boolean);
};

export const emailValidation = async (_, value) => {
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (value && !emailRegex.test(value)) {
        return Promise.reject("Invalid Email ID");
    }
    return Promise.resolve();
};

export const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    // Function to add ordinal suffix
    const getOrdinal = (n) => {
        if (n > 3 && n < 21) return n + "th"; // 4th–20th
        switch (n % 10) {
            case 1: return n + "st";
            case 2: return n + "nd";
            case 3: return n + "rd";
            default: return n + "th";
        }
    };

    return `${getOrdinal(day)} ${month} ${year}`;
}

export const isToday = (dateStr) => {
    const today = new Date();
    const d = new Date(dateStr);

    return (
        today.getDate() === d.getDate() &&
        today.getMonth() === d.getMonth()
    );
};

export const formatTimeToAMPM = (timeString) => {
    const formattedTime = moment(timeString, 'HH:mm:ss').format('h:mm A');
    return formattedTime;
};

// print and download functions
export const getPrintData = async (url, query = {}) => {
    try {
        const authtoken = sessionStorage.getItem("token");

        // Build query params
        const queryParams = new URLSearchParams();
        Object.entries(query).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                queryParams.append(key, value);
            }
        });
        queryParams.append("export_type", "pdf"); // always add pdf type

        const finalUrl = `${API_URL}/${url}?${queryParams.toString()}`;

        const requestOptions = {
            method: "GET",
            headers: { Authorization: `token ${authtoken}` },
        };

        const response = await fetch(finalUrl, requestOptions);
        if (!response.ok) {
            const errorResponse = await response.json();
            if (errorResponse && errorResponse.message) {
                throw new Error(errorResponse.message);
            } else {
                throw new Error("Something went wrong. Please try again later.");
            }
        }

        const fileBlob = await response.blob();
        const fileURL = URL.createObjectURL(fileBlob);
        window.open(fileURL);
    } catch (error) {
        ToastMsg("error", error.message);
    }
};

export const getCSVData = async (url, query = {}, type = "csv") => {
    try {
        const authtoken = sessionStorage.getItem("token");

        // Build query params
        const queryParams = new URLSearchParams();
        Object.entries(query).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                queryParams.append(key, value);
            }
        });
        queryParams.append("export_type", type === "xlsx" ? "xlsx" : "csv");

        const finalUrl = `${API_URL}/${url}?${queryParams.toString()}`;

        const requestOptions = {
            method: "GET",
            headers: { Authorization: `token ${authtoken}` },
        };

        const response = await fetch(finalUrl, requestOptions);
        if (!response.ok) {
            const errorResponse = await response.json();
            if (errorResponse && errorResponse.message) {
                throw new Error(errorResponse.message);
            } else {
                throw new Error("Something went wrong. Please try again later.");
            }
        }

        // For CSV/XLSX binary data
        const blobData = await response.arrayBuffer();
        const csvBlob = new Blob([blobData], {
            type:
                type === "xlsx"
                    ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    : "text/csv",
        });

        const csvURL = URL.createObjectURL(csvBlob);

        // Create filename with timestamp
        const currentDate = new Date();
        const formattedDate = currentDate
            .toISOString()
            .slice(0, 19)
            .replace(/[-T]/g, "")
            .replace(/:/g, "");
        const fileNameArr = url.split("/");
        let fileName = fileNameArr[fileNameArr.length - 1].replace(/_/g, "");
        fileName = fileName.charAt(0).toUpperCase() + fileName.slice(1);

        // Trigger download
        const pom = document.createElement("a");
        pom.href = csvURL;
        pom.setAttribute(
            "download",
            `${fileName}${formattedDate}.${type === "xlsx" ? "xlsx" : "csv"}`
        );
        document.body.appendChild(pom);
        pom.click();
        document.body.removeChild(pom);
    } catch (error) {
        ToastMsg("error", error.message);
    }
};

export const downloadPDF = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = "_blank"
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 19).replace(/[-T]/g, '').replace(/:/g, '');
    link.setAttribute('download', `${formattedDate}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const truncateText = (text, maxLength = 40, tooltipMaxWidth = "300px", textWrap = "wrap", emptyMessage = '-') => {
    if (!text) return emptyMessage;
    return (
        <Tooltip>
            <TooltipTrigger>
                <span className=" cursor-pointer">
                    {text.length > maxLength ? `${text.slice(0, maxLength)}...` : text}
                </span>
            </TooltipTrigger>
            {text.length > maxLength ?
                <TooltipContent
                    side="bottom"
                    sideOffset={5}
                    transition={false}
                    maxWidth={tooltipMaxWidth}
                    textWrap={textWrap}
                    className="text-xs"
                >
                    {text}
                </TooltipContent>
                : null
            }
        </Tooltip>
    );
};

export const disabledPastDate = current => {
    // If the date is before today, disable it
    return current && current < moment().startOf('day');
};

export function convertToReadableFormat(str) {
    // Split the string by underscores and capitalize each word
    const specialCharsPattern = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\]/g;
    // Use the match() method to find all occurrences of special characters
    const matches = str.match(specialCharsPattern);
    let words = str.split(matches).map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    return words.join(' ');
}

export function formatTimeSpan(input) {
    if (input) {
        const [daysPart, timePart] = input.includes('days') || input.includes('day') ? input.split(', ') : ['0 days', input];
        const [daysStr] = daysPart.split(' ');
        const days = parseInt(daysStr, 10);
        const [hours, minutes, seconds] = timePart.split(/[:,]/).map(Number);
        const totalHours = days * 24 + hours;
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');
        return `${totalHours}:${formattedMinutes}:${formattedSeconds}`;
    }
    return null;
}